<p-dialog
  header="{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.HEADER' | translate }}"
  [(visible)]="display"
  [modal]="true"
  appendTo="body"
  [draggable]="false"
  styleClass="custom-groups-dialog">

  <div>
    {{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE' | translate }}
    <ul>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_ONE' | translate}}</li>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_TWO' | translate}}</li>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_THREE' | translate}}</li>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_FOUR' | translate}}</li>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_FIVE' | translate}}</li>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_SIX' | translate}}</li>
      <li>{{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.NOTICE_LINE_SEVEN' | translate}}</li>
    </ul>
  </div>
  <button
    *gsShowIfHasPermission="['NDP_ORGANIZATION_CUSTOM_AGE_GROUP_CREATE']"
    pButton
    style="font-size:24px; width: 40px"
    (click)="addSection()"
    icon="fa fa-plus"
    class="m-b-30">
  </button>

  <div class="ui-g m-b-0">
    <div class="ui-g-4">
      <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.DEFAULT_HEADER' | translate }}</label>
    </div>
    <div class="ui-g-3">
      <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.CUSTOM_NAME_HEADER' | translate }}</label>
    </div>
    <div class="ui-g-2">
      <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_FROM_HEADER' | translate }}</label>
    </div>
    <div class="ui-g-2">
      <label>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_TO_HEADER' | translate }}</label>
    </div>
  </div>

  <div [formGroup]="groupsForm">
    <div formArrayName="groups"
         *ngFor="let item of groups.controls; let i = index;">
      <div class="ui-g m-b-0" [formGroupName]="i">
        <div class="ui-g-4">
          <gs-extended-input [control]="item.get('defaultAgeGroup')">
            <p-dropdown
              formControlName="defaultAgeGroup"
              [options]="globalGroupsItems">
            </p-dropdown>
          </gs-extended-input>
        </div>
        <div class="ui-g-3">
          <input pInputText formControlName="ageGroupName">
        </div>
        <div class=" ui-g-2">
          <gs-extended-input [control]="item.get('startingAge')">
            <input
              *ngIf="item.value.defaultAgeGroup?.groupType !== 'ADULT'"
              pInputText
              type="number"
              formControlName="startingAge">
          </gs-extended-input>
        </div>
        <div class="ui-g-2">
          <gs-extended-input [control]="item.get('endingAge')">
            <input
              *ngIf="item.value.defaultAgeGroup?.groupType !== 'ADULT'"
              pInputText
              type="number"
              formControlName="endingAge">
          </gs-extended-input>
        </div>
        <div class="ui-g-1">
          <button
            pButton
            *gsShowIfHasPermission="['NDP_ORGANIZATION_CUSTOM_AGE_GROUP_DELETE']"
            icon="fa fa-trash"
            class="delete-age-group fright"
            (click)="removeSection(i)"
            pTooltip="{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.REMOVE_TOOLTIP' | translate }}">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g">
    <div class="ui-g-12">
      <span
        *ngIf="groupsForm.errors?.ageStartEnd && groupsForm.dirty"
        class="error m-t-5 m-b-5">
        {{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_START_END' | translate }}
      </span>
      <span
        *ngIf="groupsForm.errors?.ageOverlap && groupsForm.dirty"
        class="error m-t-5 m-b-5">
        {{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_OVERLAP' | translate }}
      </span>
      <span
        *ngIf="groupsForm.errors?.ageUniqueName && groupsForm.dirty"
        class="error m-t-5 m-b-5">
        {{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_UNIQUE_NAME' | translate }}
      </span>
      <span
        *ngIf="groupsForm.errors?.ageRequired && groupsForm.dirty"
        class="error m-t-5 m-b-5">
        {{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_REQUIRED' | translate }}
      </span>
      <button
        *gsShowIfHasPermission="['NDP_ORGANIZATION_CUSTOM_AGE_GROUP_UPDATE']"
        pButton class="ui-button-success inline-block m-r-15"
        (click)="save()"
        [label]="'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.SAVE_BUTTON' | translate">
      </button>
    </div>
  </div>
  <i class="fa fa-exclamation"></i>
  {{'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.CUSTOM_AGE_GROUPS_DIALOG.AGE_GROUP_WARNING' | translate : {groups: customAgeGroupsWarning} }}
</p-dialog>
